module.exports = __webpack_public_path__ + "img/pk.b9dee0a3.svg";